var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('b-checkbox',{key:_vm.id,attrs:{"checked":_vm.value,"switch":"","disabled":!!_vm.semester.registration_open},on:{"change":_vm.setActive}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }